module.exports = __webpack_public_path__ + "img/s3.6a2ca8e4.png";